/**
 * This is the data structure stored in elastic.
 * It is populated by transforming GMX hotel data.
 */

export type StayContent = {
  hotelId: string;
  hotelName: string;
  rating: number;
  checkInTime: string; // 14:00
  checkOutTime: string; // 10:00
  hotelLogo: string;
  location?: {
    coordinates: {
      lat: number;
      lon: number;
    };
  };
  address: {
    line_1: string;
    city: string;
    state: string;
    country: string;
    postcode: string;
    countryCode: string;
  };
  createdTime: string;
  updatedTime: string;
  mappedDescriptions: Record<string, string[]>;
  descriptions: StayDescription[];
  facilities: StayFacility[];
  images: StayImage[];
  amenities: Amenity[];
  slug: string;
};

export type Amenity =
  | 'Restaurant'
  | 'Fitness facilities'
  | 'Pool'
  | 'Parking'
  | 'Free WiFi'
  | 'Laundry'
  | 'Child minding'
  | 'Bar'
  | 'Accessible'
  | 'Concierge services'
  | 'Smoke free property'
  | 'Tennis court'
  | 'Casino'
  | 'Bicycle rentals'
  | 'Spa'
  | 'Library'
  | 'Winery'
  | 'BBQ facilities'
  | 'Conference space'
  | 'Meeting rooms'
  | 'Golf course'
  | 'Multilingual staff'
  | 'Nightclub'
  | 'Maid services';

export type StayImage = {
  url: string;
  description: string;
};

export enum StayFacilityType {
  HotelFacility = 'hotel',
  RoomFacility = 'room',
  Other = 'other',
}

export type StayFacility = {
  type: StayFacilityType;
  description: string;
};

export type StayDescription = {
  language: string; // en
  title: string; // e.g. attractions
  detail: string;
};

export type StaysRoomSummary = {
  name: string;
  sleeps: number;
  beds: string;
  promotions: StaysRoomPromotion[];
};

export type StaysRoom = {
  id: string;
  available: boolean;
  price: number;
  tax: number;
  totalPrice: number;
  promotions: StaysRoomPromotion[];
  freeCancellationDate: Date | null;
  refundableDate: Date | null;
};

export type StaysRoomPromotion = {
  name: string; // make this enum? e.g. enum ('free-breakfast', etc)
  description: string;
};

export type StaysRoomImage = {
  url: string;
};

export type RequestSummary = {
  duration: number;
  durationType: durationType;
  startDate: string;
  endData: string;
};

export enum durationType {
  NA = 'NA',
  YEARS = 'YEARS',
  DAYS = 'DAYS',
  NIGHTS = 'NIGHTS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  DAY_NIGHT = 'DAY_NIGHT',
}
